import React, { useEffect, useState } from 'react'
import '../../features/Coupon/AddCouponFrom.css';
import InputField from '../../ReusableComponents/InputField';
import Form from '../../ReusableComponents/Form';
import Loading from '../../ReusableFunctions/Loader';
import Popup from '../../ReusableFunctions/Popup';
import { createAdminCoupon, getAdminCoupon, updateAdminCoupon } from '../../apis/coupons';
import ToggleField from '../../ReusableComponents/ToggleField';
import { getAllDSPs } from '../../apis/adminAPIs/dsp';
import Modal from '../../ReusableComponents/Modal';
import { Button } from '../../Components/Helper';
import SelectField from '../../ReusableComponents/SelectField';
import DatePickerField from '../../ReusableComponents/DatePickerField';
import { NoOfUserValidation, couponCodeValidation, couponMessageValidation, discountCostValidation, discountValidation, nameValidation, redemptionCountValidation, selectFieldValidation } from '../../utils/inputValidations';
import CustomToggle from '../../ReusableComponents/CustomToggle';
import CustomSelect from '../../ReusableComponents/CustomSelect';
import TextAreaField from '../../ReusableComponents/textAreaField';
import {INDIAN_STATES} from '../../appConstants'

export default function AddAdminCouponForm({ couponId, onRequestClose, coupons }) {
    const [dsps, setDsps] = useState([])
    const [coupon, setCoupon] = useState({
        name: "",
        discount_percentage: "",
        discount_cost: '',
        max_discount_value: "",
        min_order_value: "",
        max_consumption_amount: 100000,
        max_redemption_count: null,
        number_of_use_per_user: "",
        is_dsp_specific: false,
        expiry_date: new Date(),
        from_date: new Date(),
        description: "",
        coupon_code: "",
        status: true,
        is_discount_in_percentage: true,
        dsp_id: undefined,
        consumed_amount: 0,
        locations: [],
        is_public: true,
        dsps: [],
        is_dsps_edited: false,
        linked_coupon: null,
        state:{label:"All",value:'all'},
        is_state_specific:false,
        states:[],
    })

    const fetchAdminIntialData = async () => {
        try {
            const res = await getAllDSPs();
            setDsps(res.dsps);
            try {
                if (couponId) {
                    const data = await getAdminCoupon(couponId);
                    setCoupon(prev => ({
                        ...prev,
                        ...data.coupon,
                        linked_coupon: data.coupon?.linked_coupon_id ? { label: (coupons.find(c => c.id === data.coupon?.linked_coupon_id))?.coupon_code || "NA", value: (coupons.find(c => c.id === data.coupon?.linked_coupon_id))?.id } : undefined,
                        dsps: data?.coupon?.dsps.map((l) => {
                            const dsp = res.dsps.find((ds) => ds.dsp_id === l);
                            return { label: dsp?.dsp_name, value: l };
                        }),
                        expiry_date: new Date(data.coupon.expiry_date),
                        from_date: new Date(data.coupon.from_date),
                        states:data?.coupon?.states.map((s)=>{
                            const state=INDIAN_STATES.find((state)=>state===s)
                            return {label:state,value:state}
                        })
                    }));
                }
                Loading.set(false)
            } catch (err) {
                Loading.set(false)
                Popup.alert("Coupon", "Something Went wrong while getting coupon !", 'ERROR')
            }
        } catch (err) {
            Loading.set(false)
            Popup.alert("Coupon", "Something Went wrong while fetch dsps !", 'ERROR')
        }
    }

    const handleAddCoupon = (coupon) => {
        Loading.set(true);
        let modifiedCoupon = {
            ...coupon,
            linked_coupon_id: coupon.linked_coupon?.value,
            expiry_date: new Date(coupon.expiry_date).setHours(23, 59, 59, 999),
            from_date: new Date(coupon.from_date).setHours(0, 0, 0, 0),
            dsps: coupon?.dsps.map((l) => l?.value),
            states:coupon?.states?.map((state)=>state?.value)
        }
        modifiedCoupon = { ...modifiedCoupon, expiry_date: new Date(modifiedCoupon.expiry_date).toISOString(), from_date: new Date(modifiedCoupon.from_date).toISOString() }
        createAdminCoupon(modifiedCoupon).then((res) => {
            Popup.alert("Coupon", "Coupon created successfully !", 'SUCCESS')
            Loading.set(false);
            onRequestClose()
        }).catch((err) => {
            console.log("error", err);
            Loading.set(false);
            Popup.alert("Coupon", err || "Something Went wrong while creating coupon !", 'ERROR')
        })
    }

    const handleUpdateCoupon = (coupon) => {
        Loading.set(true);
        let modifiedCoupon = {
            ...coupon,
            linked_coupon_id: coupon.linked_coupon?.value,
            expiry_date: new Date(coupon.expiry_date).setHours(23, 59, 59, 999),
            dsps: coupon?.dsps.map((l) => l?.value),
            is_dsps_edited: true,
            states:coupon?.states?.map((s)=>s?.value)
        }
        modifiedCoupon = { ...modifiedCoupon, expiry_date: new Date(modifiedCoupon.expiry_date).toISOString(), from_date: new Date(modifiedCoupon.from_date).toISOString() }
        updateAdminCoupon(modifiedCoupon).then((res) => {
            Popup.alert("Coupon", "Coupon updated successfully !", 'SUCCESS')
            Loading.set(false);
            onRequestClose()
        }).catch((err) => {
            console.log("error", err);
            Loading.set(false);
            Popup.alert("Coupon", "Something Went wrong while updating coupon !", 'ERROR')
        })
    }

    useEffect(() => {
        Loading.set(true);
        fetchAdminIntialData();
    }, [])
    return (
        <Modal
            header={couponId ? "Edit Coupon" : "Create Coupon"}
            open={true}
            onClose={onRequestClose}
            contentStyle={{ width: "725px", height: "760px", borderRadius: "10px" }}
            headerContainerStyle={{ padding: "25px 30px" }}
        >
            <Form
                onSubmitForm={(coupon) => {
                    couponId ? handleUpdateCoupon(coupon) : handleAddCoupon(coupon)
                }}
                initialValues={coupon}
                style={{ display: 'flex', flexDirection: 'column', width: "100%", height: 'calc(100% - 75px)', padding: "30px" }}
            >
                {(onSubmit, formValue) => (
                    <>
                        <div
                            id='coupen-form'
                            style={{
                                width: "100%",
                                height: '100%',
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                // gridTemplateRows: "repeat(auto-fill, minmax(80px, 1fr))",
                                gridAutoRows: 'auto',
                                gap: '5px 25px',
                                overflow: 'auto'
                            }} >
                            <div className='input_field'>
                                <CustomSelect
                                    label={"Visibility"}
                                    name={"is_public"}
                                    value={coupon.is_public}
                                    onChange={(state) => {
                                        setCoupon(prev => ({
                                            ...prev,
                                            is_public: state
                                        }))
                                    }}
                                />
                            </div>
                            <div className='input_field'>
                                <CustomToggle
                                    onText={"Percentage"}
                                    offText={'Rupees'}
                                    label={"Discount Type"}
                                    name={"is_discount_in_percentage"}
                                />
                            </div>
                            <InputField
                                label={"Coupon Code"}
                                placeholder={"Enter coupon code "}
                                name={'coupon_code'}
                                validation={couponCodeValidation}
                                type={'text'}
                            />

                            <InputField
                                label={"Minimum Order Value"}
                                placeholder={"Enter minimum order amount "}
                                name={'min_order_value'}
                                type={'text'}
                                validation={discountCostValidation}
                            />
                            <TextAreaField
                                label={"Message To Be Displayed On Coupon"}
                                name={"description"}
                                placeholder={"Message to display on coupon"}
                                type={"textarea"}
                                style={{ resize: "none", height: "145px", padding: "6px 8px", background: "#F3F3F3", outline: "none" }}
                                validation={couponMessageValidation}
                            />
                            <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
                                {!formValue.is_discount_in_percentage &&
                                    <InputField
                                        label={"Fixed Discount Cost"}
                                        placeholder={"Enter discount price "}
                                        name={'discount_cost'}
                                        type={'text'}
                                        validation={discountCostValidation}
                                    />
                                }
                                {formValue.is_discount_in_percentage &&
                                    <InputField
                                        label={"Discount Percentage %"}
                                        type={'text'}
                                        placeholder={"Enter discount percentage "}
                                        name={'discount_percentage'}
                                        validation={discountValidation}
                                    />
                                }
                                {formValue.is_discount_in_percentage &&
                                    <InputField
                                        label={"Maximum Discount Amount"}
                                        placeholder={"Enter maximum discount amount "}
                                        name={'max_discount_value'}
                                        type={'text'}
                                        validation={discountCostValidation}
                                    />
                                }
                            </div>

                            <div style={{}}>
                                <div style={{ fontSize: '13px', color: '#3B3B3B' }}>Validity</div>
                                <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                                    <div style={{ width: "45%" }}>
                                        <DatePickerField
                                            label={"From Date"}
                                            name={"from_date"}
                                            dateFormat="dd/MM/yyyy" 
                                            dependentDateFields={["from_date", "expiry_date"]}
                                            validation={{
                                                validate: (value) => {
                                                    const expiryDate = new Date(formValue.expiry_date);
                                                    return value <= expiryDate || "From date cannot be greater than To date";
                                                },
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: "45%" }}>
                                        <DatePickerField
                                        dateFormat="dd/MM/yyyy" 
                                            dependentDateFields={["from_date", "expiry_date"]}
                                            label={"To Date"}
                                            name={"expiry_date"}
                                            validation={{
                                                validate: (value) => {
                                                    const fromDate = new Date(formValue.from_date);
                                                    return value >= fromDate || "To date cannot be less than From date";
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <InputField
                                label={"Maximum Usage Per User"}
                                placeholder={"Enter number of use per user "}
                                name={'number_of_use_per_user'}
                                type={'text'}
                                containerStyle={{ marginTop: "20px" }}
                                validation={NoOfUserValidation}
                            />

                            {/* {!formValue.is_discount_in_percentage && <div style={{ width: "100%" }}></div>} */}
                            <div style={{ display: "flex", gap: "2px", flexDirection: "column" }}>
                                <ToggleField
                                    name={'is_dsp_specific'}
                                    offText={"Select DSP"}
                                    onText={" "}
                                    labelStyle={{ fontSize: '13px', color: '#3B3B3B', }}
                                />
                                {formValue.is_dsp_specific &&
                                    <div style={{ marginTop: "-9px", position: 'relative' }}>
                                        <SelectField
                                        isSearchable
                                            name='dsps'
                                            isMulti
                                            styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                            list={dsps.map(l => ({ label: l.dsp_name, value: l.dsp_id }))}
                                            containerStyle={{
                                                width: "100%",
                                                maxWidth: "100%",
                                                minHeight: "80px",
                                            }}
                                            menuPortalTarget={document.getElementById('modalHolder')}
                                            validation={selectFieldValidation}
                                            controlStyle={{ height: "auto" }}
                                        />
                                    </div>
                                }

                            </div>

                            <InputField
                                label={"Maximum Redemption Count"}
                                placeholder={"Enter maximum redemption count"}
                                name={'max_redemption_count'}
                                type={'text'}
                                containerStyle={{ marginTop: "14px" }}
                                validation={redemptionCountValidation}
                            />

                                <SelectField
                                label={"Linked Coupon"}
                                    name='linked_coupon'
                                    isSearchable
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={coupons.map(c => ({ label: c.coupon_code, value: c.id }))}
                                    containerStyle={{
                                        width: "100%",
                                    }}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                />

                         <div style={{ display: "flex", gap: "2px", flexDirection: "column",marginTop:"-10px" }}>
                                <ToggleField
                                    name={'is_state_specific'}
                                    offText={"Select State"}
                                    onText={" "}
                                    labelStyle={{ fontSize: '13px', color: '#3B3B3B', }}
                                />
                                {formValue.is_state_specific &&
                                    <div style={{ marginTop: "-15px", position: 'relative' }}>
                                        <SelectField
                                        isSearchable
                                            name='states'
                                            isMulti
                                            styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                            list={INDIAN_STATES.sort().map(state => ({ label: state, value: state }))}
                                            containerStyle={{
                                                width: "100%",
                                                maxWidth: "100%",
                                                minHeight: "80px",
                                            }}
                                            menuPortalTarget={document.getElementById('modalHolder')}
                                            validation={selectFieldValidation}
                                            controlStyle={{ height: "auto" }}
                                        />
                                    </div>
                                }

                            </div>
                        </div>
                        <div style={{ display: "flex", width: "100%", justifyContent: 'right', gap: '20px', alignItems: "end",marginTop:"15px" }}>
                                <Button
                                    text={"Cancel"}
                                    type={"button"}
                                    onClick={onRequestClose}
                                    isBtnNotActive={true}
                                    className={"btn-large "}
                                />

                                <Button
                                    text={couponId ? "Update" : "Create"}
                                    className={"btn-large"}
                                    type={"submit"}
                                    onClick={onSubmit}
                                />
                            </div>
                    </>
                )}
            </Form>
        </Modal>
    )
}

